function hasLocalStorage() {
  if (!('localStorage' in window)) {
    return false;
  }

  try {
    const key = 'Quick claim localstorage test available';
    localStorage.setItem(key, 'test');
    localStorage.getItem(key);
    localStorage.removeItem(key);
  } catch (error) {
    return false;
  }
  return true;
}

function temporaryStorage() {
  const data = {};

  return {
    // @ts-ignore
    getItem: (key: string): any => data[key],
    setItem: (key: string, value: any) => {
      // @ts-ignore
      data[key] = String(value);
    },
    removeItem: (key: string) => {
      // @ts-ignore
      delete data[key];
    },
  };
}

const storage = hasLocalStorage() ? localStorage : temporaryStorage();

export const getItem = (key: string): any => storage.getItem(key);

export const setItem = (key: string, value: any) => storage.setItem(key, value);

export const removeItem = (key: string) => storage.removeItem(key);
